import CampaignHeader from './CampaignHeader';

export type { CampaignHeaderProps } from './CampaignHeader';

export default CampaignHeader;
